module.exports = __webpack_public_path__ + "static/media/icon_trailing.a18b894b.svg";